import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GetUserProfileMe } from '@app/shared/actions/common-data.action';
import { UserProfile } from '@app/shared/classes/user-profile';
import { CommonDataState } from '@app/shared/stores/common-data.state';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-set-apex-id',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './set-apex-id.component.html',
  styleUrl: './set-apex-id.component.css'
})
export class SetApexIdComponent {
  store = inject(Store);

  @Select(CommonDataState.profileMe) profileMe$: Observable<UserProfile>;

  constructor(private route: ActivatedRoute) {
    var apexdId = this.route.snapshot.paramMap.get('apexid');
    if (apexdId) {
      this.store.dispatch(new GetUserProfileMe(apexdId));
    }
  }
}
